// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file feedback_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyRequestSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { Feedback } from "./feedback_pb";
import { file_feedback } from "./feedback_pb";
import type { Reservation } from "./reservation_pb";
import { file_reservation } from "./reservation_pb";
import type { FeedbackSettings } from "./feedback_settings_pb";
import { file_feedback_settings } from "./feedback_settings_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file feedback_service.proto.
 */
export const file_feedback_service: GenFile = /*@__PURE__*/
  fileDesc("ChZmZWVkYmFja19zZXJ2aWNlLnByb3RvEgtncnBjLmFwaS52MSIxChpGZWVkYmFja0dldEZlZWRiYWNrUmVxdWVzdBITCgtmZWVkYmFja19pZBgBIAEoAyJDChhGZWVkYmFja0ZlZWRiYWNrUmVzcG9uc2USJwoIZmVlZGJhY2sYASABKAsyFS5ncnBjLmFwaS52MS5GZWVkYmFjayJcChtGZWVkYmFja0xpc3RGZWVkYmFja3NQYXJhbXMSEgoKYmVnaW5fZGF0ZRgBIAEoBRIQCghlbmRfZGF0ZRgCIAEoBRIXCg9zaW5jZV9kdF9jcmVhdGUYAyABKAMiWAocRmVlZGJhY2tMaXN0RmVlZGJhY2tzUmVxdWVzdBI4CgZwYXJhbXMYASABKAsyKC5ncnBjLmFwaS52MS5GZWVkYmFja0xpc3RGZWVkYmFja3NQYXJhbXMiRwocRmVlZGJhY2tMaXN0RmVlZGJhY2tSZXNwb25zZRInCghmZWVkYmFjaxgBIAEoCzIVLmdycGMuYXBpLnYxLkZlZWRiYWNrIkwKHUZlZWRiYWNrR2V0UmVzZXJ2YXRpb25SZXF1ZXN0EhMKC2ZlZWRiYWNrX2lkGAEgASgDEhYKDnJlc2VydmF0aW9uX2lkGAIgASgDIkwKG0ZlZWRiYWNrUmVzZXJ2YXRpb25SZXNwb25zZRItCgtyZXNlcnZhdGlvbhgBIAEoCzIYLmdycGMuYXBpLnYxLlJlc2VydmF0aW9uIk0KGkZlZWRiYWNrU2V0U2V0dGluZ3NSZXF1ZXN0Ei8KCHNldHRpbmdzGAEgASgLMh0uZ3JwYy5hcGkudjEuRmVlZGJhY2tTZXR0aW5ncyJLChhGZWVkYmFja1NldHRpbmdzUmVzcG9uc2USLwoIc2V0dGluZ3MYASABKAsyHS5ncnBjLmFwaS52MS5GZWVkYmFja1NldHRpbmdzMvEDCg9GZWVkYmFja1NlcnZpY2USXQoLZ2V0RmVlZGJhY2sSJy5ncnBjLmFwaS52MS5GZWVkYmFja0dldEZlZWRiYWNrUmVxdWVzdBolLmdycGMuYXBpLnYxLkZlZWRiYWNrRmVlZGJhY2tSZXNwb25zZRJnCg1saXN0RmVlZGJhY2tzEikuZ3JwYy5hcGkudjEuRmVlZGJhY2tMaXN0RmVlZGJhY2tzUmVxdWVzdBopLmdycGMuYXBpLnYxLkZlZWRiYWNrTGlzdEZlZWRiYWNrUmVzcG9uc2UwARJmCg5nZXRSZXNlcnZhdGlvbhIqLmdycGMuYXBpLnYxLkZlZWRiYWNrR2V0UmVzZXJ2YXRpb25SZXF1ZXN0GiguZ3JwYy5hcGkudjEuRmVlZGJhY2tSZXNlcnZhdGlvblJlc3BvbnNlEk8KC2dldFNldHRpbmdzEhkuZ3JwYy5hcGkudjEuRW1wdHlSZXF1ZXN0GiUuZ3JwYy5hcGkudjEuRmVlZGJhY2tTZXR0aW5nc1Jlc3BvbnNlEl0KC3NldFNldHRpbmdzEicuZ3JwYy5hcGkudjEuRmVlZGJhY2tTZXRTZXR0aW5nc1JlcXVlc3QaJS5ncnBjLmFwaS52MS5GZWVkYmFja1NldHRpbmdzUmVzcG9uc2VCBloELjtwYmIGcHJvdG8z", [file_empty, file_feedback, file_reservation, file_feedback_settings]);

/**
 * @generated from message grpc.api.v1.FeedbackGetFeedbackRequest
 */
export type FeedbackGetFeedbackRequest = Message<"grpc.api.v1.FeedbackGetFeedbackRequest"> & {
  /**
   * @generated from field: int64 feedback_id = 1;
   */
  feedbackId: bigint;
};

/**
 * Describes the message grpc.api.v1.FeedbackGetFeedbackRequest.
 * Use `create(FeedbackGetFeedbackRequestSchema)` to create a new message.
 */
export const FeedbackGetFeedbackRequestSchema: GenMessage<FeedbackGetFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_feedback_service, 0);

/**
 * @generated from message grpc.api.v1.FeedbackFeedbackResponse
 */
export type FeedbackFeedbackResponse = Message<"grpc.api.v1.FeedbackFeedbackResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Feedback feedback = 1;
   */
  feedback?: Feedback | undefined;
};

/**
 * Describes the message grpc.api.v1.FeedbackFeedbackResponse.
 * Use `create(FeedbackFeedbackResponseSchema)` to create a new message.
 */
export const FeedbackFeedbackResponseSchema: GenMessage<FeedbackFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_feedback_service, 1);

/**
 * @generated from message grpc.api.v1.FeedbackListFeedbacksParams
 */
export type FeedbackListFeedbacksParams = Message<"grpc.api.v1.FeedbackListFeedbacksParams"> & {
  /**
   * @generated from field: int32 begin_date = 1;
   */
  beginDate: number;

  /**
   * @generated from field: int32 end_date = 2;
   */
  endDate: number;

  /**
   * @generated from field: int64 since_dt_create = 3;
   */
  sinceDtCreate: bigint;
};

/**
 * Describes the message grpc.api.v1.FeedbackListFeedbacksParams.
 * Use `create(FeedbackListFeedbacksParamsSchema)` to create a new message.
 */
export const FeedbackListFeedbacksParamsSchema: GenMessage<FeedbackListFeedbacksParams> = /*@__PURE__*/
  messageDesc(file_feedback_service, 2);

/**
 * @generated from message grpc.api.v1.FeedbackListFeedbacksRequest
 */
export type FeedbackListFeedbacksRequest = Message<"grpc.api.v1.FeedbackListFeedbacksRequest"> & {
  /**
   * @generated from field: grpc.api.v1.FeedbackListFeedbacksParams params = 1;
   */
  params?: FeedbackListFeedbacksParams | undefined;
};

/**
 * Describes the message grpc.api.v1.FeedbackListFeedbacksRequest.
 * Use `create(FeedbackListFeedbacksRequestSchema)` to create a new message.
 */
export const FeedbackListFeedbacksRequestSchema: GenMessage<FeedbackListFeedbacksRequest> = /*@__PURE__*/
  messageDesc(file_feedback_service, 3);

/**
 * @generated from message grpc.api.v1.FeedbackListFeedbackResponse
 */
export type FeedbackListFeedbackResponse = Message<"grpc.api.v1.FeedbackListFeedbackResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Feedback feedback = 1;
   */
  feedback?: Feedback | undefined;
};

/**
 * Describes the message grpc.api.v1.FeedbackListFeedbackResponse.
 * Use `create(FeedbackListFeedbackResponseSchema)` to create a new message.
 */
export const FeedbackListFeedbackResponseSchema: GenMessage<FeedbackListFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_feedback_service, 4);

/**
 * @generated from message grpc.api.v1.FeedbackGetReservationRequest
 */
export type FeedbackGetReservationRequest = Message<"grpc.api.v1.FeedbackGetReservationRequest"> & {
  /**
   * @generated from field: int64 feedback_id = 1;
   */
  feedbackId: bigint;

  /**
   * @generated from field: int64 reservation_id = 2;
   */
  reservationId: bigint;
};

/**
 * Describes the message grpc.api.v1.FeedbackGetReservationRequest.
 * Use `create(FeedbackGetReservationRequestSchema)` to create a new message.
 */
export const FeedbackGetReservationRequestSchema: GenMessage<FeedbackGetReservationRequest> = /*@__PURE__*/
  messageDesc(file_feedback_service, 5);

/**
 * @generated from message grpc.api.v1.FeedbackReservationResponse
 */
export type FeedbackReservationResponse = Message<"grpc.api.v1.FeedbackReservationResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Reservation reservation = 1;
   */
  reservation?: Reservation | undefined;
};

/**
 * Describes the message grpc.api.v1.FeedbackReservationResponse.
 * Use `create(FeedbackReservationResponseSchema)` to create a new message.
 */
export const FeedbackReservationResponseSchema: GenMessage<FeedbackReservationResponse> = /*@__PURE__*/
  messageDesc(file_feedback_service, 6);

/**
 * @generated from message grpc.api.v1.FeedbackSetSettingsRequest
 */
export type FeedbackSetSettingsRequest = Message<"grpc.api.v1.FeedbackSetSettingsRequest"> & {
  /**
   * @generated from field: grpc.api.v1.FeedbackSettings settings = 1;
   */
  settings?: FeedbackSettings | undefined;
};

/**
 * Describes the message grpc.api.v1.FeedbackSetSettingsRequest.
 * Use `create(FeedbackSetSettingsRequestSchema)` to create a new message.
 */
export const FeedbackSetSettingsRequestSchema: GenMessage<FeedbackSetSettingsRequest> = /*@__PURE__*/
  messageDesc(file_feedback_service, 7);

/**
 * @generated from message grpc.api.v1.FeedbackSettingsResponse
 */
export type FeedbackSettingsResponse = Message<"grpc.api.v1.FeedbackSettingsResponse"> & {
  /**
   * @generated from field: grpc.api.v1.FeedbackSettings settings = 1;
   */
  settings?: FeedbackSettings | undefined;
};

/**
 * Describes the message grpc.api.v1.FeedbackSettingsResponse.
 * Use `create(FeedbackSettingsResponseSchema)` to create a new message.
 */
export const FeedbackSettingsResponseSchema: GenMessage<FeedbackSettingsResponse> = /*@__PURE__*/
  messageDesc(file_feedback_service, 8);

/**
 * @generated from service grpc.api.v1.FeedbackService
 */
export const FeedbackService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.FeedbackService.getFeedback
   */
  getFeedback: {
    methodKind: "unary";
    input: typeof FeedbackGetFeedbackRequestSchema;
    output: typeof FeedbackFeedbackResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.FeedbackService.listFeedbacks
   */
  listFeedbacks: {
    methodKind: "server_streaming";
    input: typeof FeedbackListFeedbacksRequestSchema;
    output: typeof FeedbackListFeedbackResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.FeedbackService.getReservation
   */
  getReservation: {
    methodKind: "unary";
    input: typeof FeedbackGetReservationRequestSchema;
    output: typeof FeedbackReservationResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.FeedbackService.getSettings
   */
  getSettings: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof FeedbackSettingsResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.FeedbackService.setSettings
   */
  setSettings: {
    methodKind: "unary";
    input: typeof FeedbackSetSettingsRequestSchema;
    output: typeof FeedbackSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_feedback_service, 0);

